<template>
    <div class="gray-back" style="height: 100%" >
        <div class="box">
            <van-tabs v-model="active" class="tab-nav" sticky @click="onStatusChange">
                <van-tab title="赛场成绩查询">
                    <van-form
                            style="margin-top: 20px"
                            @submit="onSubmit"
                            @failed="onFailed"
                    >
                        <van-cell-group>

                            <van-field
                                    readonly
                                    clickable
                                    right-icon="arrow"
                                    input-align="right"
                                    @click="showSaijiPicker=true"
                                    label="赛季"
                                    v-model="formData.saijiName"
                            />
                            <van-popup v-model="showSaijiPicker" position="bottom">
                                <van-picker :columns="saijiColumns"
                                            show-toolbar
                                            :default-index="0"
                                            @cancel="showSaijiPicker = false"
                                            @confirm="onSaijiConfirm"
                                />
                            </van-popup>


                        </van-cell-group>

                        <!-- <div style="text-align: center">
                            <van-button
                                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                                    style="width: 3rem"
                                    size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."  >搜索</van-button>
                        </div> -->
                    </van-form>
                </van-tab>


            </van-tabs>


            <div style="margin-top: 10px ;" v-if="list.length>0">
                <van-cell-group  >
                    <van-cell @click="toResult(item)" v-for="(item,k) in list" :key="k" :title="item.name" is-link  />
                </van-cell-group>

            </div>


            <div class="" v-if="emptyShow">
                <van-empty style="margin: 10px auto" description="暂无结果" />
            </div>
        </div>

    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 50px;*/
        background: rgba(248,248,248,1);
        min-height: 90vh;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }
    .van-pull-refresh{
        margin-top: 0.3rem
    }
    .title-left span{
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(0,0,0,1);
    }
    .normal-btn {
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(0,0,0,1);
        line-height:26px;
        width:75px;
        height:26px;
        border-radius:13px;
        border:1px solid rgba(0,0,0,1);
        margin-right: 0.5rem;
    }

    .count_edit {
        width:87px;
        height:26px;
        background:linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
        border-radius:13px;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:26px;
        margin-right: 0.5rem
    }

    .row-list {
        border-bottom: 0.1rem solid #EFEFEF;
        background: #fff;
        margin: 0.2rem;
        border-radius: 0.2rem;
    }

    .row-title-img {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.1rem;
    }

    .row-title {
        padding: 0.1rem 0.33rem;
    }

    .title-right {
        color: #FD2840;
    }



    .row-left {
        width: 80%;
    }

    .row-right {
        text-align: center;
    }

    .goods-detail {
        width: 72%;
    }

    .row-left-img {
        width: 1.44rem;
        height: 1.44rem;
        border-radius: 5px;
        margin-right: 0.2rem;
    }

    .row-goods {
        padding: 0.2rem 0.3rem;
        border-bottom: 1px solid #EFEFEF;
    }

    .goods-name {
        font-size: 12px;
        margin-bottom: 0.6rem;
    }

    .goods-price {
        font-size: 16px;
        margin: 0.1rem 0 0.6rem;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(253,40,64,1);
    }

    .goods-price span {
        font-size: 12px;
    }

    .goods-num {
        font-size: 12px;
    }
    .pay_order{
        width:87px;
        height:26px;
        background:linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
        border-radius:13px;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:26px;
        margin-right: 0.5rem
    }

    .row-btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0.2rem 0.33rem;
        font-size: 12px;
        text-align: center;
        line-height: 0.52rem;
    }

    .look-order {
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(0,0,0,1);
        line-height:26px;
        width:75px;
        height:26px;
        border-radius:13px;
        border:1px solid rgba(0,0,0,1);
        margin-right: 0.5rem;
    }

    .invite-btn {
        width: 2.1rem;
        height: 0.52rem;
        background: rgba(255, 0, 0, 1);
        border: 1px solid rgba(255, 0, 0, 1);
        border-radius: 4px;
        color: #fff;
    }

</style>

<script>
    import Vue from 'vue';

    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import {Cell, CellGroup, Toast, Dialog, Icon, PullRefresh, List, Tag, Button,DropdownMenu, DropdownItem,
            Tab,
            Tabs,
            NoticeBar,Empty
    } from 'vant';
    import LoginDialog from '@/components/LoginDialog.vue';

    Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(Tab).use(Tabs).use(DropdownItem);
    export default {
        name: 'GoodsList',
        components: {
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
            [Empty.name]: Empty,
            LoginDialog,
        },
        data: function () {
            return {
                validator,
                isSubmit: false,
                loginShow: false,
                emptyShow: false,
                showSaijiPicker: false,
                showSubPicker: false,
                showArea:false,
                areaList:{},
                saveLoading: false,
                active: 0,
                isLoading: false,
                loading: false,
                finished: false,
                params: {
                    pageNo: 1,
                    pageSize: 5,
                    status: 0
                },
                homeTop : 0,
                list: [],
                sjsqOptions: [],
                saijiColumns:[
                ],
                formData:{
                    saijiIndex:1,
                    saijiName:'教练员',
                    subName:'',
                    subValue:'',
                },
                subColums:[],
                subLabel:""
            }
        },
        mounted() {
            let that = this;
            document.title = "赛事查询"
//            that.formData.saijiName = this.saijiColumns[0];
            that.getSjsq();
        },
        destroyed() {
        },
        methods: {

            getSjsq(){
                let that = this;
                that.$api.post('/api/sai/sjsqScoreOptions', {
                }, (res) => {
                    if(res.data){
                        that.sjsqOptions = res.data;
                        that.saijiColumns = that.sjsqOptions.map(item =>{
                            return item.name
                        });
                        that.formData.saijiName = that.sjsqOptions[0].name;
                        that.list = that.sjsqOptions[0].children;
                    }
                } )
            },

            toResult(item){
                rbLink({
                    name:'SaiResult',query:{saiqu : item.id ,old:item.old}
                });

            },

            onSaijiConfirm(value, index){
                this.formData.saijiName = value;
                this.formData.saijiIndex = index+1;
                this.list = this.sjsqOptions[index].children;
                this.showSaijiPicker = false;
            },

            onSubmit(values){
                console.log('onSubmit-values',values);
                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                }
                that.saveLoading = true;

                that.$api.post('/api/cha/danwei', {
                    name:that.formData.name,
                }, (res) => {
                    if(res.data){
                        that.list = res.data;
                        if(res.data.length==0){
                            that.emptyShow  = true;
                        }else{
                            that.emptyShow  = false;
                        }
                    }
                    that.isSubmit = true;
                    that.saveLoading = false;
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            onRefresh() {
                let that = this;
                that.params.pageNo = 1;
                that.getList();
            },


            // 更改状态
            onStatusChange(index) {

                let that = this;
            },

            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },

        }
    }
</script>



// WEBPACK FOOTER //
// SearchSai.vue?5b9285ba